<template>
<div>
  <!--конопка показать рец-->
  <md-button
      style="background: #ffa726 !important;"
      class="ms-success ms-block mb-3 mt-3"
      :disabled="buttonDisabled"
      @click="showRec()"
  ><md-icon>library_books</md-icon> Показать рецептуру </md-button>
  <!--чекбоксы для показа рец данных-->
  <div class="mb-2 mt-3" v-if="show_rec">
    <md-checkbox v-model="checkboxManual" @click="checkboxManual =!checkboxManual ">Дозы</md-checkbox>
    <md-checkbox v-model="checkboxMl" @click="checkboxMl=!checkboxMl">Мл</md-checkbox>
    <md-checkbox v-model="checkboxShot" @click="checkboxShot=!checkboxShot">Shot</md-checkbox>
  </div>
  <!--таблица с рецептурами-->
  <table class="table table-bordered" style="background-color: #fff;" v-if="show_rec">
    <thead>
    <tr>
      <th scope="col">#</th>
      <th scope="col" v-show="checkboxManual">У</th>
      <th scope="col" v-show="checkboxManual">Д</th>
      <th scope="col" v-show="checkboxManual">1/2</th>
      <th scope="col" v-show="checkboxManual">1/4</th>
      <th scope="col" v-show="checkboxMl">мл</th>
      <th scope="col" v-show="checkboxShot">shot</th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="(item,index) in recRecount" :key="index">
      <th scope="row">{{index}}</th>
      <th scope="row" v-show="checkboxManual">{{item.unc}}</th>
      <th scope="row" v-show="checkboxManual">{{item.doz}}</th>
      <th scope="row" v-show="checkboxManual">{{item.one}}</th>
      <th scope="row" v-show="checkboxManual">{{item.two}}</th>
      <th scope="row" v-show="checkboxMl">{{item.ml}}</th>
      <th scope="row" v-show="checkboxShot">{{item.shot}}</th>
    </tr>
    </tbody>
  </table>

</div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: "RecipeSection",
  props: ['color_name','weight'],
  data() {
    return{
      checkboxManual: true,
      checkboxMl: false,
      checkboxShot: false,
      buttonDisabled: false,
      show_rec: false,
      arrStory: [],
      shot: 0.154,
      yn: 29.568,
      doz: 0.616,
      one2: 0.308,
      one4: 0.154,
      recRecount: {},
      color_info: null,
    }
  },
  computed: {
    ...mapGetters(['recipe']),
  },
  methods: {
    ...mapActions(['loadStory']),
    recipes(){
      let colorantSystem = this.recipe.data.colorant_system;
      let recipe = this.recipe.data.new_recipe_colorants;
      //////////после смены колорантов удалить if блок//
      if (colorantSystem === 'old'){
        recipe = this.recipe.data.old_recipe_colorants;
      }
      return recipe;
    },
    showRec() {
      let recipe = this.recipes();
      recipe.forEach(element => this.recountRecipe(element.colorant.name, element.value))
      this.show_rec = true;
      this.buttonDisabled = true;
      this.$emit('buttonDisabled')
      this.sendToStoryOld();

    },
    recountRecipe(name, value) {

      this.recRecount[name] = {};
      let res = this.weight / this.recipe.data.product.product_desc * this.recipe.data.product.coefficient;
      let recYnc = 0;
      let recDoz = 0;
      let recOne2 = 0;
      /*
      если значение res*value (обьем колоранта с учетом веса и коефициента) Больше или равно 29.568
      */
      if (res*value >= this.yn) {
        //получаем остаток от деления на 29.568
        recDoz = res * value % this.yn
        //получаем округленное в меньшую сторону количество делений на 29.568
        recYnc = Math.floor(res*value / this.yn)
        //помещаем в масив unc количетво делений
        this.recRecount[name]['unc'] = recYnc;
      }else{
        //помещаем в масив unc  цифру 0
        this.recRecount[name]['unc'] = 0;
        //присваиваем recDoz входное значение
        recDoz = res*value
      }
      /*
      если значение recDoz (обьем колоранта с учетом веса и коефициента) Больше или равно 0.616
      */
      if (recDoz >= this.doz ) {
        //получаем остаток от деления на 0.616
        recOne2 = (recDoz % this.doz)
        //получаем округленное в меньшую сторону количество делений на 0.616
        recDoz = Math.floor(recDoz / this.doz)
        //помещаем в масив doz количетво делений
        this.recRecount[name]['doz'] = recDoz;

      }else {
        //помещаем в масив doz  цифру 0
        this.recRecount[name]['doz'] = 0;
        //присваиваем recOne2 входное значение
        recOne2 = res*value
      }

      if (recOne2 >= 0.539){
        this.recRecount[name]['doz'] +=1;
        recOne2 = 0;
      }
      /*
     если значение recOne2 (обьем колоранта с учетом веса и коефициента) Больше или равно 0.308 - 0.77
     */
      if(recOne2 >= this.one2 - 0.077) {
        //помещаем в масив one = 1
        this.recRecount[name]['one'] = 1;
        //отнимаем от recOne2 - 0.308
        recOne2 = recOne2 - this.one2;
      } else {
        this.recRecount[name]['one'] = 0;
      }
      /*
     если значение recOne2 (обьем колоранта с учетом веса и коефициента) Больше 0.77
     */
      if (recOne2 > 0.077 ) {
        this.recRecount[name]['two'] = 1;
      } else {
        this.recRecount[name]['two'] = 0;
      }

      this.recRecount[name]['ml'] = (res*value).toFixed(1);
      this.recRecount[name]['shot'] = (res*value / this.shot).toFixed(1);

    },
    sendToStoryOld() {
      let recipe = this.recipes();
      this.arrStory = [];
      this.arrStory.push(this.color_name);
      for (let i in recipe) {
        let val = recipe[i].value * (this.weight/this.recipe.data.product.product_desc
            * this.recipe.data.product.coefficient);
        this.arrStory.push({
          'colorant_name': recipe[i].colorant.name,
          'value': val
        });

      }
      this.loadStory(this.arrStory)
      /* this.$store.dispatch('loadStory', this.arr)*/


    },
  }
}
</script>

<style scoped>

</style>